import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import * as serviceWorker from './serviceWorker'
import App from './App'
import { ProviderWithRouter } from './components'
import theme from './theme'
import './styles/index.css'


const container = document.getElementById('nemi-amb-web')!
const root = createRoot(container)
root.render(
    <ThemeProvider theme={ theme }>
      <BrowserRouter>
        <ProviderWithRouter>
          <App />
        </ProviderWithRouter>
      </BrowserRouter>
    </ThemeProvider>
)
serviceWorker.unregister()
